<template>
  <div class="download" :class="isCollapse ? 'download-collapse' : ''">
    <div>
      <div class="title">{{ $router.lang.get('下載新墨魂Online') }}</div>
      <div class="sub-title">
        {{ $router.lang.get('邀請你來到新墨魂Online') }}
      </div>
    </div>
    <div class="butt-container">
      <pang-butt btype="plain" eventstr="signup_download">
        <div class="butt blue" @click="goto('/account/register')">
          <div>{{ $router.lang.get('註冊會員') }}</div>
          <div>{{ $router.lang.get('註冊《新墨魂Online》遊戲賬號') }}</div>
        </div>
      </pang-butt>
      <pang-butt btype="plain" eventstr="download_download">
        <div class="butt yellow" @click="goto('/download')">
          <div>{{ $router.lang.get('遊戲下載') }}</div>
          <div>{{ $router.lang.get('windows遊戲主程式') }}</div>
        </div>
      </pang-butt>
    </div>
    <div class="hint">
      <div>{{ $router.lang.get('例行維護時間：每週四 10:00~13:00') }}</div>
      <div>{{ $router.lang.get('客服服務時間：週一至週五 9:30~18:30') }}</div>
      <div>
        {{ $router.lang.get('警察公函的往來：help@mohunonline.com') }}
      </div>
    </div>
    <div class="fans-container" :class="isCollapse ? 'collapse' : ''">
      <div class="fans">
        <div v-if="screenState.screenWidth > 500">
          {{ $router.lang.get('官方粉絲團') }}
        </div>
        <div>
          <img
            class="logo"
            @click="gotoOpen('https://www.facebook.com/mohunonlinetw')"
            src="../../../assets/images/img_facebook.png"
          />
        </div>
        <div
          class="open-butt"
          @click="gotoOpen('https://www.facebook.com/mohunonlinetw')"
          v-if="screenState.screenWidth > 500"
        >
          {{ $router.lang.get('前往粉絲團') }}
        </div>
      </div>
      <div class="fans">
        <div v-if="screenState.screenWidth > 500">DISCORD</div>
        <div>
          <img
            class="logo"
            @click="gotoOpen('https://discord.com/invite/Pqkh8X9')"
            src="../../../assets/images/img_discord.png"
          />
        </div>
        <div
          class="open-butt"
          @click="gotoOpen('https://discord.com/invite/Pqkh8X9')"
          v-if="screenState.screenWidth > 500"
        >
          {{ $router.lang.get('前往DISCORD') }}
        </div>
      </div>
      <div class="fans">
        <div v-if="screenState.screenWidth > 500">
          {{ $router.lang.get('哈啦板') }}
        </div>
        <div>
          <img
            class="logo"
            @click="gotoOpen('https://forum.gamer.com.tw/A.php?bsn=38561')"
            src="../../../assets/images/img_baha.png"
          />
        </div>
        <div
          class="open-butt"
          @click="gotoOpen('https://forum.gamer.com.tw/A.php?bsn=38561')"
          v-if="screenState.screenWidth > 500"
        >
          {{ $router.lang.get('前往哈啦板') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useScreenState } from '../../../store'
import { PangButt } from '../../../components'
import browser from '../../../utils/browser'

export default {
  name: 'Download',
  components: {
    PangButt
  },
  data() {
    return {
      screenState: useScreenState()
    }
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900
    }
  },
  methods: {
    gotoOpen(url) {
      if (browser.isPc) window.open(url, '_blank')
      else window.location = url
    },
    goto(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>
.download {
  color: #c6a86c;
  padding-top: calc(120 / 1920 * 100vw);
  padding-bottom: 100px;
  font-weight: normal;
  text-align: center;
}

.download > div {
  max-width: 1200px;
  width: 90vw;
  margin-left: auto;
  margin-right: auto;
}

.title {
  font-size: 2.6vw;
  color: #000000;
}

.sub-title {
  font-size: 1.3vw;
}

.butt-container {
  display: flex;
  justify-content: center;
}

.butt {
  max-width: 351px;
  width: 22vw;
  height: 6vw;
  display: flex;
  flex-direction: column;
  margin: 1.5vw 0.5vw;
  cursor: pointer;
}

.butt:hover {
  -moz-opacity: 0.9 !important;
  filter: alpha(opacity=90);
  opacity: 0.9;
  -moz-opacity: 0.9;
}

.butt > div {
  color: #ffffff;
}

.butt > div:first-child {
  font-size: 1.8vw;
  margin-top: 0.9vw;
}

.butt > div:last-child {
  font-size: 1vw;
}

.blue {
  background-image: url('~@/assets/images/but_zhuce.png');
  margin-left: auto;
}

.yellow {
  background-image: url('~@/assets/images/but_download.png');
  margin-right: auto;
}

.blue,
.yellow {
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.hint {
  font-size: 1vw;
  color: #939393;
  line-height: 1.5vw;
}

.fans-container {
  margin-top: 1vw;
  padding-top: 1vw;
  border-top: 1px solid #e7e8eb;
  -o-border-image: linear-gradient(to left, #fff, #e7e8eb, #fff) 8 10 8;
  border-image: linear-gradient(to left, #fff, #e7e8eb, #fff) 8 10 8;
}

.fans {
  display: inline-block;
  max-width: 288px;
  width: calc(30vw - 2px);
  border-left: 1px solid #e7e8eb;
  -o-border-image: linear-gradient(to top, #fff, #e7e8eb, #fff) 8 10 8;
  border-image: linear-gradient(to top, #fff, #e7e8eb, #fff) 8 10 8;
}

.fans:first-child {
  border-left: none;
}

.fans > div {
  margin: 1vw 0;
}

.fans > div:first-child {
  font-size: 2vw;
  font-weight: bold;
  color: #403f3e;
}

.fans > div:last-child {
  font-size: 1.1vw;
  margin: auto;
}

@media screen and (min-width: 1920px) {
  .butt > div:last-child {
    font-size: 20px;
  }
  .fans > div:last-child {
    font-size: 18px;
  }
}

.open-butt {
  height: 2.5vw;
  line-height: 2.5vw;
  max-width: 200px;
  width: 10vw;
  border: 1px solid #c6a86c;
  border-radius: 1.25vw;
  cursor: pointer;
}

.open-butt:hover {
  color: #fff;
  background: #debe7e;
}

.logo {
  max-width: 163px;
  width: calc(30vw - 30px);
  margin: 1vw auto;
  cursor: pointer;
}

.collapse {
  margin-top: 20px;
  padding-top: 20px;
}

.collapse > .fans > div {
  margin-top: 20px;
}

.collapse > .fans > div:first-child {
  font-size: calc(3.33vw + 10px);
}

.collapse > .fans > div:last-child {
  font-size: calc(1vw + 9px);
}

.download-collapse > div:last-child {
  display: flex;
  flex-direction: row;
}

.download-collapse > div {
  flex-direction: column;
  font-size: calc(0.3vw + 13.3px);
  line-height: calc(0.8vw + 13.3px);
}

.download-collapse .butt {
  width: 48vw;
  min-width: 200px;
  margin: 20px auto;
  min-height: 50px;
}

.download-collapse .butt > div {
  font-size: calc(1vw + 7px);
}

.download-collapse .title {
  font-size: calc(2vw + 22px);
  line-height: calc(3vw + 22px);
}

.download-collapse .sub-title {
  font-size: calc(1vw + 13px);
  line-height: calc(2vw + 13px);
}

.butt-container > div {
  margin: 0;
}
</style>
